<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!-- begin: Single Modal -->
    <router-view />
    <!-- end: Single Modal -->
    <!--begin::Form-->
    <form class="kt-form" ref="form">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <!-- Begin:วันที่เช็คอิน -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">วันที่เช็คอิน :</label>
                <span class="form-control-plaintext">{{ chdCheckInDate }}</span>
              </div>
            </div>
            <!-- End:วันที่เช็คอิน -->

            <!-- Begin:ชื่อ-สกุลผู้เช็คอิน -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">ชื่อ-สกุลผู้เช็คอิน :</label>
                <span class="form-control-plaintext">{{ chdFullname }}</span>
              </div>
            </div>
            <!-- End:ชื่อ-สกุลผู้เช็คอิน -->

            <!-- Begin:ร้านค้า -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">ร้านค้า :</label>
                <span class="form-control-plaintext">{{ chdShopName }}</span>
              </div>
            </div>
            <!-- End:ร้านค้า -->

            <!-- Begin:ร้านค้า 2 -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">ร้านค้า 2 :</label>
                <span class="form-control-plaintext">{{ chdShopName2 }}</span>
              </div>
            </div>
            <!-- End:ร้านค้า 2 -->

            <!-- Begin:คะแนนรวม -->
            <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label">คะแนนรวม :</label>
                <span class="form-control-plaintext">{{ chdTotalScore }}</span>
              </div>
            </div>
            <!-- End:คะแนนรวม -->
          </div>

          <div class="kt-section kt-section--first" v-show="chdCheckInBarcodes!=null && chdCheckInBarcodes.length > 0">
            <h3 class="kt-section__title">รายการ Barcode ที่เช็คอิน:</h3>
            <div class="kt-section__body">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table
                    class="table table-sm table-striped table-bordered table-hover table-checkable"
                  >
                    <thead>
                      <tr>
                        <th class="text-center" width="5%">ลำดับ</th>
                        <th class="text-center" width="25%">รหัส Barcode</th>
                        <th class="text-center" width="20%">
                          รหัสบาร์โค้ดเก่า
                        </th>
                        <th class="text-center" width="20%">
                          แบรนด์ของหัวจ่าย
                        </th>
                        <th class="text-center" width="20%">รูปภาพ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, i) in chdCheckInBarcodes" :key="i">
                        <td class="text-center stock-item-td">{{ i + 1 }}</td>
                        <td class="text-center stock-item-td">
                          {{ row.barcodeNo }}
                        </td>
                        <td class="text-center stock-item-td">
                          {{ row.barcodeNoOld }}
                        </td>
                        <td class="text-center stock-item-td">
                          {{
                            showDispenserProductBrands(
                              row.dispenserProductBrands
                            )
                          }}
                        </td>
                        <td class="text-center stock-item-td">
                          <a
                            href="#"
                            @click.prevent="pictureModal(row.fileUrl)"
                            title="รูปภาพ"
                            v-if="row.fileUrl != null"
                            >Link</a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="kt-section kt-section--first">
            <h3 class="kt-section__title">แบบสอบถาม:</h3>
            <div class="kt-section__body">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table
                    class="table table-sm table-striped table-bordered table-hover table-checkable"
                  >
                    <thead>
                      <tr>
                        <th class="text-center" width="5%">ลำดับ</th>
                        <th class="text-center" width="40%">หัวข้อ</th>
                        <th
                          class="text-center"
                          width="10%"
                          v-for="(row, i) in chdChoices"
                          :key="i"
                        >
                          {{ row.text }} <br />
                          ({{ row.point.text }})
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, i) in chdQuestions" :key="i">
                        <td class="text-center stock-item-td">{{ i + 1 }}</td>
                        <td class="stock-item-td">
                          {{ row.text }}
                        </td>
                        <td
                          class="text-center stock-item-td"
                          v-for="(choice, j) in row.choices"
                          :key="j"
                        >
                          <span v-for="(survey, k) in chdSurveys" :key="k">
                            <span v-if="row.code == survey.questionCode">
                              <span v-if="choice.code == survey.answerCode">
                                X &nbsp;
                                <!-- <a
                                  href="#"
                                  @click.prevent="pictureModal(survey.fileUrl)"
                                  title="รูปภาพ"
                                  v-if="choice.isRequiredPicture"
                                  >Link</a
                                > -->

                                <a
                                  href="#"
                                  @click.prevent="pictureModal(survey.fileUrl)"
                                  title="รูปภาพ" 
                                  v-if="choice.isRequiredPicture && (survey.fileUrl != null && !survey.isImgCloud)" 
                                  >Link  </a
                                >
                                <a
                                  href="javascript:void(0);"
                                  @click="showModal(survey.fileUrl)"
                                  title="รูปภาพ"
                                  v-if="choice.isRequiredPicture && (survey.fileUrl != null && survey.isImgCloud) "
                                  >Link </a
                                >
                                
                              </span>
                            </span>
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center" colspan="2">คะแนนรวม</th>
                        <th class="text-center" colspan="4">
                          {{ chdTotalScore }}
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="imageModal" tabindex="-1" role="dialog" aria-labelledby="imageModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content mr-4">
            <div class="modal-header">
              <h5 class="modal-title">ภาพถ่าย</h5>
              <button type="button" class="close" aria-label="Close" @click="closeModal">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body"> 
              <img :src="modalImageURL" class="img-thumbnail mb-3" style="height: auto; width: auto;"> 
            </div>
            <div class="modal-footer">
              <button type="button" data-dismiss="modal" class="btn btn-secondary"  aria-label="Close" @click="closeModal"><i class="la la-close"></i> ปิดหน้าต่าง
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import router from "../../router";

export default {
  data: function() {
    var self = this;
    return {
      modalImageURL: '',
      chdCheckInDate: null,
      chdFullname: null,
      chdShopName: null,
      chdShopName2: null,
      chdTotalScore: null,
      chdCheckInBarcodes: null,
      chdSurveys: null,
      chdQuestions: null,
      chdChoices: null,
      chdCheckInItemId: null,
      chdCheckOutDate: null,
      chdCheckOutFullname: null,
    };
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios
      .get("/Api/QICheckIn/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          //console.log(response.data);
          if (response.data != null) {
            self.chdCheckInDate = response.data.checkInDateFormat;
            self.chdFullname = response.data.checkInByUserFullName;
            if(response.data.shopTypeCode == "SUB_AGENT"){
              self.chdShopName = response.data.subAgentShopName;
              self.chdShopName2 = response.data.subAgentShopName2;
            }
            else{
              self.chdShopName = response.data.shopName;
              self.chdShopName2 = response.data.shopName2;
            }
           
            self.chdTotalScore = response.data.totalScore;
            self.chdCheckInBarcodes = response.data.checkInBarcodes;
            self.chdSurveys = response.data.surveyItems;
            self.chdCheckInItemId = response.data.checkInItemId;
            self.chdCheckOutDate = response.data.checkOutDateFormat;
            self.chdCheckOutFullname = response.data.checkOutByUserFullName;
            self.buildDisplayQuestions();
          }
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลการเช็คอินร้านค้าคุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลการเช็คอินร้านค้าได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });

    axios
      .get("/Api/QICheckIn/MaintenanceSurvey")
      .then(function(response) {
        if (response.status == 200) {
          //console.log(response.data);
          if (response.data != null) {
            self.chdQuestions = response.data.questions;
            self.chdChoices = self.chdQuestions[0].choices;
            self.buildDisplayQuestions();
          }
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่สามารถดึงข้อมูลแบบสอบถามได้",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลแบบสอบถามได้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  },
  methods: {
    showModal(imageURL) { 
      this.modalImageURL = imageURL;
      this.isFromImageModal = true;
      $('#imageModal').modal('show');
      $('#imageModal').on('hidden.bs.modal', () => {
        $('body').addClass('modal-open');
      });
    },
    closeModal() {
      $('#imageModal').modal('hide');
    },
    showDispenserProductBrands(items) {
      var text = "";
      //console.log(items);
      if (items != null && items.length > 0) {
        for (let i = 0; i < items.length; i++) {
          text +=
            "[" + items[i].productBrandId + "] " + items[i].productBrandName;
          if (i != items.length - 1) text += ", ";
        }
      }
      return text;
    },
    // CR-1: สร้าง question rows จาก survey items จริง (รองรับ transaction เก่าที่มีหัวข้อถูก soft delete)
    buildDisplayQuestions() {
      if (!this.chdSurveys || this.chdSurveys.length === 0 || !this.chdQuestions || !this.chdChoices) return;

      // Build map of master data questions by code
      var masterMap = {};
      for (var i = 0; i < this.chdQuestions.length; i++) {
        masterMap[this.chdQuestions[i].code] = this.chdQuestions[i];
      }

      // Extract unique question codes from survey items (in submission order)
      var seenCodes = {};
      var surveyQuestionCodes = [];
      for (var i = 0; i < this.chdSurveys.length; i++) {
        var code = this.chdSurveys[i].questionCode;
        if (!seenCodes[code]) {
          seenCodes[code] = true;
          surveyQuestionCodes.push({
            code: code,
            text: this.chdSurveys[i].questionText
          });
        }
      }

      // Check if all survey codes exist in master data
      var hasMissingCodes = false;
      for (var i = 0; i < surveyQuestionCodes.length; i++) {
        if (!masterMap[surveyQuestionCodes[i].code]) {
          hasMissingCodes = true;
          break;
        }
      }

      // If all codes exist in master data, keep master data order (new transaction)
      if (!hasMissingCodes) return;

      // Old transaction: rebuild questions from survey items
      var displayQuestions = [];
      for (var i = 0; i < surveyQuestionCodes.length; i++) {
        var sq = surveyQuestionCodes[i];
        if (masterMap[sq.code]) {
          // Use master data version (has correct choices + isRequiredPicture)
          displayQuestions.push(masterMap[sq.code]);
        } else {
          // Construct question from survey item snapshot
          var choices = [];
          for (var j = 0; j < this.chdChoices.length; j++) {
            var c = this.chdChoices[j];
            choices.push({
              code: c.code,
              text: c.text,
              order: c.order,
              point: c.point,
              isRequiredPicture: false
            });
          }
          displayQuestions.push({
            code: sq.code,
            text: sq.text,
            order: 0,
            choices: choices
          });
        }
      }

      this.chdQuestions = displayQuestions;
    },
    pictureModal(fileUrl) {
      var self = this;
      let router = this.$router;
      //console.log(fileUrl);
      if (fileUrl != null) {
        router.push({
          path: `/QC/QCCheckIn/Detail/${
            self.chdCheckInItemId
          }/Picture/${encodeURIComponent(fileUrl)}`,
        });
      } else Swal.fire("เกิดข้อผิดพลาด", "กรุณาคลิก Link", "error");
    },
  },
};
</script>
<style lang="css">
.stock-item-td {
  color: #6c7293;
}
</style>



// WEBPACK FOOTER //
// App/Components/QICheckIn/CheckInDetail.vue